<template>
  <div v-if="airlines!=null">
    <div v-for="(item, index) in airlines" :key="index" style="position: relative;">
      <pdk-ckeckbox
        class="checkBox"
        type="checkbox"
        :name="'selection' + index"
        :value="item.airLineName"
        @change="selectAirline"
      >
        <img class="mb8 airlins-logo" :src="getLogoUrl(item[0].airLineLogo)" />
        {{item[0].airLineTitle}}
      </pdk-ckeckbox>
    </div>
  </div>
  <div v-else>
     
        <div style="text-align: right; margin-top: 5px; margin-right: 2px;" class="the-icons">
          <i class="icon-spin6 animate-spin"></i>
 
        </div>
      
  </div>
</template>

<script>
import CheckBox from "@/components/PdkCheckBox";

export default {
  name: "pdk-Airline-Filter",
  components: { "pdk-ckeckbox": CheckBox },
  props: { airlines: Array },
  data() {
    return {
      open: false,
      message: "Accordion",
    };
  },
  methods: {
    selectAirline(event) {
    },
    getLogoUrl(name) {
      return "../img/airlines/" + name + ".png";
    },
  },
};
</script>

<style>
.airlins-logo {
  width: 30px;
  background-size: cover;
}

.mb8 {
  margin-bottom: 8px;
}

.checkBox {
  margin-right: 5px;
}
</style>


